import CookiePolicyPopupTypes from "./cookiePolicyPopup.types";

export const hideCookiePolicyPopup = () => {
  return {
    type: CookiePolicyPopupTypes.HIDE_COOKIEPOLICY_POPUP,
  };
};